<template>
    <h1 class="alert alert-danger d-flex justify-content-center">
دسترسی به صفحه مورد نظر برای شما امکان پذیر نمی باشد.
    </h1>
</template>

<script>
export default {
  name: "access-denied",
  created: () => {},
  components: {},
  data() {
    return {};
  }
};
</script>